import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const SplitText = ({
  text = "",
  className = "",
  splitType = "words", // 'words' or 'chars'
  tag = "h1",
  duration = 0.6,
  ease = "power3.out",
  stagger = 0.06,
  delay = 0, // milliseconds
  threshold = 0.1,
  rootMargin = "0px",
}) => {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el || !text) return;

    const selector =
      splitType === "chars" ? ".split-char" : ".split-word";
    const targets = el.querySelectorAll(selector);
    if (!targets || targets.length === 0) return;

    const tween = gsap.fromTo(
      targets,
      { opacity: 0, y: 20, scale: 0.98 },
      {
        opacity: 1,
        y: 0,
        scale: 1,
        duration,
        ease,
        stagger,
        delay: delay / 1000,
        scrollTrigger: {
          trigger: el,
          start: `top ${Math.round((1 - threshold) * 100)}%`,
          once: true,
        },
        force3D: true,
        willChange: "transform, opacity",
      }
    );

    return () => {
      try {
        tween.kill();
      } catch (e) {
        /* noop */
      }
      ScrollTrigger.getAll().forEach((st) => {
        if (st.trigger === el) st.kill();
      });
    };
  }, [text, splitType, duration, ease, stagger, delay, threshold, rootMargin]);

  const Tag = tag;
  const renderSegments = () => {
    if (splitType === "words") {
      return text.split(" ").map((w, i) => (
        <span key={i} className="split-word">
          {w}
          {i < text.split(" ").length - 1 ? "\u00A0" : ""}
        </span>
      ));
    }
    // chars
    return text.split("").map((c, i) => (
      <span key={i} className="split-char">
        {c === " " ? "\u00A0" : c}
      </span>
    ));
  };

  return (
    <Tag ref={ref} className={`split-parent ${className}`}>
      {renderSegments()}
    </Tag>
  );
};

export default SplitText;












